import React from 'react';
import { Heart, UserPlus, MessageCircle, AtSign } from 'lucide-react';
import { Avatar } from './shared';
import { alerts } from '../mock';

const ICON = {
  like: { Icon: Heart, cls: 'bg-[#3a1220] text-[#f43f5e]' },
  follow: { Icon: UserPlus, cls: 'bg-[#122a3a] text-[#2f8bff]' },
  comment: { Icon: MessageCircle, cls: 'bg-[#12322a] text-[#22c55e]' },
  mention: { Icon: AtSign, cls: 'bg-[#2a2440] text-[#a78bfa]' },
};

export default function Alerts() {
  return (
    <div>
      <p className="px-4 py-3 text-[13px] text-[#8b95a5] font-medium">Recent</p>
      <ul>
        {alerts.map((a) => {
          const { Icon, cls } = ICON[a.type];
          return (
            <li key={a.id} className="flex items-center gap-3 px-4 py-3 hover:bg-[#0e1522] transition-colors animate-fade-up">
              <div className="relative">
                <Avatar src={a.avatar} size={46} />
                <span className={`absolute -bottom-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center ring-2 ring-[#05070c] ${cls}`}>
                  <Icon size={11} className="fill-current" />
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-[14px] text-[#dbe1ea] leading-snug">
                  <span className="font-semibold text-white">{a.user}</span> {a.text}
                </p>
                <span className="text-[12px] text-[#5c6675]">{a.time} ago</span>
              </div>
              {a.image ? (
                <img src={a.image} alt="" className="w-11 h-11 rounded-lg object-cover" />
              ) : (
                <button className="text-[13px] font-semibold text-white bg-[#2f8bff] px-4 py-1.5 rounded-lg active:scale-95 transition-transform">
                  Follow
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
